import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import GameLeaderboard from 'components/GameLeaderboard';
import './GameLeaderboardModal.css';

const GameLeaderboardModal = ({
  show,
  gameData,
  handleClose,
  maximizedClassSuffix
}) => {
  return (
    <Modal
      className={`game-leaderboard-modal${maximizedClassSuffix}`}
      show={show}
      onHide={handleClose}
    >
      <Modal.Body>
        <GameLeaderboard
          show={show}
          gameData={gameData}
          handleClose={handleClose}
        />
      </Modal.Body>
    </Modal>
  );
};

GameLeaderboardModal.propTypes = {
  show: PropTypes.bool.isRequired,
  gameData: PropTypes.object,
  handleClose: PropTypes.func
};

export default GameLeaderboardModal;
